// Custom filled disc SVG for change indicator
type ChangeDiscProps = {
  size?: number
  color?: string
  [key: string]: unknown
}

export const ChangeDisc = ({
  size = 16,
  color = 'var(--color-change-disc)',
  ...props
}: ChangeDiscProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <circle cx="8" cy="8" r="7" fill={color} />
  </svg>
)
